// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__24UHm","spinner-anim":"Loader_spinner-anim__ULZ_A"};